module.exports = __webpack_public_path__ + "img/undoMarks.bb9f7a0a.svg";